import { BRAND } from "themes";

export const styles = {
  titleRow: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  appliedFilters: {
    color: BRAND.muted,
    font: "normal normal 500 12px/16px Roboto",
  },
  filterButton: {
    borderColor: BRAND.border,
    color: BRAND.ink,
    textTransform: "none" as const,
    font: "normal normal 600 13px/18px Roboto",
    borderRadius: "12px",
    padding: "4px 12px",
    marginLeft: "12px",
  },
  filterFields: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  filterHint: {
    color: BRAND.muted,
    font: "normal normal 500 12px/16px Roboto",
    marginTop: "12px",
  },
  clearFilters: {
    minWidth: 0,
    padding: "6px 10px",
    color: BRAND.secondary,
    font: "normal normal 600 13px/18px Roboto",
    textTransform: "none" as const,
  },
  feedbackText: {
    maxWidth: 280,
    color: BRAND.ink,
    font: "normal normal 400 14px/20px Roboto",
    overflowWrap: "anywhere" as const,
    whiteSpace: "normal" as const,
  },
  plainCell: {
    color: "#364152",
    font: "normal normal 400 14px/20px Roboto",
  },
  stateCard: {
    marginTop: "16px",
    padding: "32px 20px",
    textAlign: "center" as const,
    backgroundColor: "#fff",
    border: `1px solid ${BRAND.border}`,
    borderRadius: "12px",
  },
  stateTitle: {
    color: BRAND.ink,
    font: "normal normal 600 16px/22px Roboto",
    marginBottom: "6px",
  },
  stateText: {
    color: BRAND.muted,
    font: "normal normal 400 14px/20px Roboto",
    marginBottom: "16px",
  },
  detailGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: "16px 20px",
  },
  detailLabel: {
    color: BRAND.muted,
    font: "normal normal 600 12px/16px Roboto",
    letterSpacing: "0.03em",
    textTransform: "uppercase" as const,
    marginBottom: "4px",
  },
  detailValue: {
    color: BRAND.ink,
    font: "normal normal 500 14px/20px Roboto",
    overflowWrap: "anywhere" as const,
  },
  feedbackBody: {
    margin: 0,
    color: "#364152",
    font: "normal normal 400 14px/22px Roboto",
    whiteSpace: "pre-wrap" as const,
    overflowWrap: "anywhere" as const,
  },
  ratingRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  detailImage: {
    display: "block",
    width: "100%",
    maxHeight: 220,
    objectFit: "contain" as const,
    marginTop: "12px",
    borderRadius: "12px",
    border: `1px solid ${BRAND.border}`,
    backgroundColor: BRAND.track,
  },
  imageSection: {
    marginTop: "14px",
  },
  galleryHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    marginBottom: "10px",
  },
  galleryTitle: {
    color: BRAND.ink,
    font: "normal normal 600 13px/18px Roboto",
  },
  imageCount: {
    color: BRAND.muted,
    font: "normal normal 500 12px/16px Roboto",
    letterSpacing: "0.02em",
  },
  galleryStage: {
    position: "relative",
  },
  galleryNavBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    width: 34,
    height: 34,
    borderRadius: "10px",
    border: `1px solid ${BRAND.border}`,
    backgroundColor: "rgba(255,255,255,0.94)",
    color: BRAND.ink,
    boxShadow: "0 4px 12px rgba(27, 19, 64, 0.08)",
    transition: "background-color 160ms ease, border-color 160ms ease",
    "&:hover": {
      backgroundColor: "#fff",
      borderColor: "#D8D5E5",
    },
    "&.feedback-gallery-prev": {
      left: 10,
    },
    "&.feedback-gallery-next": {
      right: 10,
    },
  },
  galleryMain: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: { xs: 220, sm: 280 },
    height: { xs: 220, sm: 280 },
    borderRadius: "14px",
    border: `1px solid ${BRAND.border}`,
    background: "linear-gradient(180deg, #FBFBFD 0%, #F4F3F8 100%)",
    overflow: "hidden",
    cursor: "zoom-in",
    outline: "none",
    transition: "border-color 160ms ease, box-shadow 160ms ease",
    "&:hover": {
      borderColor: "#D8D5E5",
      boxShadow: "0 8px 24px rgba(27, 19, 64, 0.06)",
    },
    "&:hover .feedback-gallery-zoom-hint, &:focus-visible .feedback-gallery-zoom-hint":
      {
        opacity: 1,
        transform: "translate(-50%, 0)",
      },
  },
  galleryImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain" as const,
    display: "block",
    padding: "12px",
    animation: "feedbackGalleryFade 220ms ease",
    "@keyframes feedbackGalleryFade": {
      from: { opacity: 0.35 },
      to: { opacity: 1 },
    },
  },
  galleryZoomHint: {
    position: "absolute",
    left: "50%",
    bottom: 14,
    transform: "translate(-50%, 6px)",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    px: 1.25,
    py: 0.75,
    borderRadius: "10px",
    backgroundColor: "rgba(27, 19, 64, 0.78)",
    color: "#fff",
    font: "normal normal 500 12px/16px Roboto",
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 160ms ease, transform 160ms ease",
  },
  thumbnailRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "12px",
    overflowX: "auto",
    pb: 0.5,
  },
  thumbnailBtn: {
    flex: "0 0 auto",
    width: 58,
    height: 58,
    padding: 0,
    borderRadius: "10px",
    border: `1px solid ${BRAND.border}`,
    backgroundColor: "#fff",
    overflow: "hidden",
    cursor: "pointer",
    opacity: 0.72,
    transition: "opacity 160ms ease, border-color 160ms ease, transform 160ms ease",
    "&:hover": {
      opacity: 1,
      borderColor: "#D8D5E5",
    },
  },
  thumbnailBtnActive: {
    opacity: 1,
    borderColor: BRAND.ink,
    boxShadow: "0 0 0 1px rgba(27, 19, 64, 0.12)",
    transform: "translateY(-1px)",
  },
  thumbnailImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
    display: "block",
  },
  lightboxRoot: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    bgcolor: "rgba(12, 10, 24, 0.92)",
    outline: "none",
    p: { xs: 1.5, sm: 2.5 },
  },
  lightboxToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    mb: 1.5,
  },
  lightboxTitle: {
    color: "rgba(255,255,255,0.88)",
    font: "normal normal 500 14px/20px Roboto",
  },
  lightboxClose: {
    color: "#fff",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.16)",
    backgroundColor: "rgba(255,255,255,0.06)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.12)",
    },
  },
  lightboxStage: {
    position: "relative",
    flex: 1,
    minHeight: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  lightboxNavBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    color: "#fff",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.16)",
    backgroundColor: "rgba(255,255,255,0.08)",
    width: 48,
    height: 48,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.14)",
    },
    "&.feedback-lightbox-prev": {
      left: { xs: 4, sm: 8 },
    },
    "&.feedback-lightbox-next": {
      right: { xs: 4, sm: 8 },
    },
  },
  lightboxFrame: {
    width: "100%",
    height: { xs: "58vh", sm: "72vh" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.08)",
    backgroundColor: "rgba(255,255,255,0.03)",
    overflow: "hidden",
    px: { xs: 5, sm: 8 },
  },
  lightboxImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain" as const,
    display: "block",
  },
  lightboxThumbs: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    mt: 2,
    overflowX: "auto",
    pb: 0.5,
  },
  lightboxThumbBtn: {
    flex: "0 0 auto",
    width: 54,
    height: 54,
    padding: 0,
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.18)",
    backgroundColor: "transparent",
    overflow: "hidden",
    cursor: "pointer",
    opacity: 0.55,
    transition: "opacity 160ms ease, border-color 160ms ease",
    "&:hover": {
      opacity: 0.9,
    },
  },
  lightboxThumbBtnActive: {
    opacity: 1,
    borderColor: "#fff",
  },
  lightboxThumbImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
    display: "block",
  },
  people: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: "16px",
    marginTop: "20px",
    paddingTop: "16px",
    borderTop: `1px solid ${BRAND.border}`,
  },
  personRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: 0,
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: "12px",
    objectFit: "cover" as const,
    flexShrink: 0,
    border: `1px solid ${BRAND.border}`,
    backgroundColor: BRAND.track,
  },
};
